import { VehicleOwnership } from '@/modules/Vehicle/interfaces/vehicle'

export const vehicleOwnershipOptions = [
  {
    label: 'Own',
    value: VehicleOwnership.OWN
  },
  {
    label: 'Finance',
    value: VehicleOwnership.FINANCE
  },
  {
    label: 'Lease',
    value: VehicleOwnership.LEASE
  }
]

export const showOwnershipLabel = (val: VehicleOwnership |string | null) => {
  if (!val) {
    return null
  }
  const ownershipObject = vehicleOwnershipOptions.find((option) => option.value === val)
  return ownershipObject && ownershipObject.label ? ownershipObject.label : ''
}
